import { render, staticRenderFns } from "./PayeeInfoView.vue?vue&type=template&id=715e3e9a&scoped=true&"
import script from "./PayeeInfoView.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoView.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInfoView.vue?vue&type=style&index=0&id=715e3e9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715e3e9a",
  null
  
)

export default component.exports